import { env } from '../../constants'

import Logo from './components/logo'
import Profile from './components/profile'
import Award from './components/award'
import Form from './components/form'

import styles from './styles.module.css'

const Home = props => {
  return (
    <div className={styles.wrapper}>
      <header className={styles.header_wrapper}>
        <div className={styles.header}>
          <Logo />
        </div>
      </header>

      <main className={styles.main}>
        <div className={styles.section_wrapper}>
          <div className={styles.section_container}>
            <div>
              <div className={styles.row}>
                <div className={styles.col}>
                  <div className={styles.col_item}>
                    <div className={styles.col_item_inner}>
                      <div className={styles.content_wrap}>
                        <div className={styles.content}>
                          <div className={styles.content_header}>
                            <h1>
                              <span>Splashtop</span>
                              <span>Secure</span>
                              <span>Workspace</span>
                            </h1>
                          </div>
                          
                          <div className={styles.content_body}>
                            <Profile />
                          </div>
                          
                          <div className={styles.content_body}>
                            <Award />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.col}>
                  <div className={styles.col_item_inner}>
                    <div>
                      <div className={styles.form_title}>
                        <h1>Secure Workspace</h1>
                      </div>
                      <div className={styles.form_wrap}>
                        <div className={styles.form}>
                          <header className={styles.form_header}>
                            <h1>Let's get you signed up</h1>
                          </header>
                          <Form />
                          <footer className={styles.form_footer}>
                            <p className={styles.form_login}>Signed up already? <a href={`https://${env.RUNTIME_DOMAIN}`}>Log in here</a></p>
                          </footer>
                        </div>

                        <div className={styles.terms}>
                          <p>By completing the form I agree to the Splashtop <a href="https://www.splashtop.com/legal/terms-of-service" target="_blank" rel="noreferrer">Terms of Service</a> and <a href="https://www.splashtop.com/legal/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a></p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}

export default Home
